import { RETRACK_CLICK_COOKIE } from '~/config/constants';
import { get as getCookie } from './cookie';

export const getRetrackClick = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  // Honor the user's decision at read time, even if the cookie still lingers —
  // there's a window between Cookiebot declining marketing consent and the
  // server-side middleware clearing the cookie on the next GET.
  if (window.Cookiebot?.consent?.marketing === false) {
    return null;
  }

  try {
    return getCookie(RETRACK_CLICK_COOKIE);
  } catch {
    return null;
  }
};
